// extracted by mini-css-extract-plugin
export default {"iconWrapper":"Icon-module_iconWrapper_LCeuJ","iconImg":"Icon-module_iconImg_Xrvq8","iconImgSelected":"Icon-module_iconImgSelected_iKuBE"};